/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const GALLERY_SERVICE = {postGallery, getGallery, deleteGalleryById};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Gallery";

/* Services */
//Service to create gallery items
function postGallery(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated gallery items
function getGallery(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to remove gallery items
function deleteGalleryById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

